<template>
  <div class="fontWeight">
    <appModal></appModal>
    <div v-if="spinner">
      <div class="centered">
        <a-spin />
      </div>
    </div>
    <div v-if="this.$route.query.isEmail && Object.keys(this.$route.query).length > 0" class="row m-2 justify-content-center">
      <div class="col-sm-12 col-xs-12 col-lg-6 col-md-6 borderClass p-4">
        <label for="subject">Subject</label>
        <b-form-input v-model="subject" name="subject"></b-form-input>

        <label for="message" class="my-2">Message</label>
        <b-form-textarea v-model="message" placeholder="Enter message..." rows="3" max-rows="6" name="message"></b-form-textarea>

        <label for="replyToEmail" class="my-2">Reply to email</label>
        <b-form-input v-model="replyToEmail" name="replyToEmail"></b-form-input>

        <label for="toEmail" class="my-2">To email</label>
        <b-form-input v-model="toEmail" name="toEmail" required></b-form-input>

        <label for="ccEmail" class="my-2">CC: Email</label>
        <b-form-input v-model="CCEmail" name="ccEmail"></b-form-input>

        <label for="flagBatch" class="my-2">Flag batch as sent</label>
        <b-form-checkbox id="checkbox-1" v-model="flagBatch" name="flagBatch" value="true" unchecked-value="false"> </b-form-checkbox>
        <b-button @click="sendOrdersViaEmail()" class="buttonStyle my-2" variant="primary">Send Orders Via Email</b-button>
      </div>
    </div>
    <div v-if="getFaxData.length > 0">
      <div class="row m-2 justify-content-center" v-for="fax in getFaxData" :key="fax.order_number">
        <div class="col-sm-12 col-xs-12 col-lg-6 col-md-6 borderClass p-2">
          <div class="textCentre">
            <b style="font-size: large">Order</b>
            <br />
            <b>Transmission Date: {{ fax.order_date }}</b>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-1 col-xs-1 col-lg-1 col-md-1">
              <p>To:</p>
            </div>
            <div class="col-sm-5 col-xs-5 col-lg-5 col-md-5">
              <p class="textUnderline">
                {{ fax.supplier_name ? fax.supplier_name : '-' }}
              </p>
              <div class="row">
                <div class="col">
                  <p>Fax:</p>
                </div>
                <div class="col">
                  <p>{{ fax.supplier_fax ? fax.supplier_fax : '-' }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>Phone Num:</p>
                </div>
                <div class="col">
                  <p>{{ fax.supplier_phone ? fax.supplier_phone : '-' }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>Attn:</p>
                </div>
                <div class="col">
                  <p>{{ fax.supplier_contact ? fax.supplier_contact : '-' }}</p>
                </div>
              </div>
            </div>
            <div class="col-sm-1 col-xs-1 col-lg-1 col-md-1 borderLeft">
              <p>From:</p>
            </div>
            <div class="col-sm-5 col-xs-5 col-lg-5 col-md-5">
              <p class="textUnderline">Taico Incentive Services Inc.</p>
              <div class="row">
                <div class="col">
                  <p>Address:</p>
                </div>
                <div class="col">
                  <p>67 Paterson Village Crt Bulding F Patterson, NY 12563</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>Fax:</p>
                </div>
                <div class="col">
                  <p>845 940 4506</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>Phone Num:</p>
                </div>
                <div class="col">
                  <p>845 228 4438</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>Acct Num:</p>
                </div>
                <div class="col">
                  <p></p>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="textCentre my-2">
            <b>
              Order Num:
              <span class="textUnderline">{{ fax.order_number ? fax.order_number : '-' }}</span>
            </b>
          </div>
          <table>
            <tr>
              <th style="width: 10%">Qty</th>
              <th style="width: 15%">Unit Cost</th>
              <th style="width: 15%">Product ID</th>
              <th style="width: 45%">Product Name</th>
              <th style="width: 15%">Attributes</th>
            </tr>
            <tr>
              <td>{{ fax.quantity ? fax.quantity : '-' }}</td>
              <td>{{ fax.prod_cost ? `$${fax.prod_cost}` : '-' }}</td>
              <td>{{ fax.prod_id ? fax.prod_id : '-' }}</td>
              <td>{{ fax.prod_name ? fax.prod_name : '-' }}</td>
              <td>
                {{ fax.prod_size ? fax.prod_size : '-' }}
              </td>
            </tr>
          </table>

          <div class="row borderClass p-1 m-1 my-4">
            <div
              class="
                col-sm-8 col-xs-8 col-lg-8 col-md-8
                offset-sm-2 offset-xs-2 offset-lg-2 offset-md-2
              "
            >
              <div class="text-center">
                <b>Shipping Info:</b>
              </div>
              <br />
              <div class="row">
                <div class="col">
                  <p>Recipient</p>
                </div>
                <div class="col">
                  <p>{{ fax.first_name ? `${fax.first_name} ` : '' }}{{ fax.last_name ? `${fax.last_name} ` : '' }}</p>
                  <p>{{ fax.co_name ? `${fax.co_name} ` : '' }}</p>
                  <p>
                    {{ fax.address1 ? `${fax.address1}, ` : '' }}{{ fax.address2 ? `${fax.address2}, ` : ''
                    }}{{ fax.user_city ? `${fax.user_city}, ` : '' }}{{ fax.user_state ? `${fax.user_state}, ` : ''
                    }}{{ fax.zip ? `${fax.zip}` : '' }}
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>Day Phone</p>
                </div>
                <div class="col">
                  <p>{{ fax.day_phone ? fax.day_phone : '-' }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>Evening Phone</p>
                </div>
                <div class="col">
                  <p>{{ fax.evening_phone ? fax.evening_phone : '-' }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>Email</p>
                </div>
                <div class="col">
                  <p>{{ fax.email ? fax.email : '-' }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row borderClass p-1 m-1">
            <p style="font-size: 10px">
              By accepting this and future purchase orders from us, you (supplier) agree that all customer information, including but not limited to
              name, address and any ordering data, belongs to us and remains proprietary. In accepting this and future orders you also agree not to
              solicit any business from Taico's customers. All customer information remains the sole property of Taicoï¿½ and shall not be used by you
              except in fulfilling orders from Taico and you shall not distribute this customer information to any third party under any
              circumstances. Supplier also agrees that any artwork provided by Taicoï¿½ remains the property of Taicoï¿½ and shall be immediately
              returned to us upon request."
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row m-4 text-center">
      <p>Processing ...</p>
    </div>
  </div>
</template>

<script>
import { getMonthDateYearForFax } from '../utilities/date';
import divvyAdminModal from '@/components/divvyAdminModal.vue';

export default {
  name: 'faxComponent',

  components: {
    appModal: divvyAdminModal,
  },

  data() {
    return {
      subject: '',
      message: '',
      replyToEmail: 'info@divvyengagement.com',
      toEmail: '',
      CCEmail: '',
      flagBatch: true,
      spinner: false,
    };
  },

  methods: {
    sendOrdersViaEmail() {
      if (!this.toEmail.trim()) {
        this.$store.commit('divvySystemMessage/SET_MODAL_MESSAGE', `Enter To email id`);
        return;
      }
      this.spinner = true;

      var params = {
        batch_number: +this.$route.query.batchNo ? +this.$route.query.batchNo : 0,
        order_number: this.$route.query.orderId ? this.$route.query.orderId : '',
        to_email: this.toEmail,
        from_email: this.replyToEmail,
        cc_email: this.CCEmail,
        subject: this.subject,
        message: this.message,
        flag_as_sent: this.flagBatch ? 1 : 0,
      };

      this.$store
        .dispatch('faxEmail/sendOrdersViaEmail', params)
        .then(() => {
          this.spinner = false;

          // setting blank msg
          this.$store.commit('divvySystemMessage/SET_MODAL_MESSAGE', '');

          // setting modal message
          this.$store.commit('divvySystemMessage/SET_MODAL_MESSAGE', `Your order has been emailed to ${this.toEmail}`);
        })
        .catch(() => {
          this.spinner = false;
          console.log('error from sendOrdersViaEmail vue');
        });
    },
  },

  computed: {
    getFaxData() {
      return this.$store.getters['faxEmail/getFaxData'];
    },
  },

  watch: {
    getFaxData(getFaxData) {
      getFaxData.forEach((fax) => {
        fax.order_date = getMonthDateYearForFax();
      });
    },
  },

  created() {
    this.$store.commit('faxEmail/SET_FAX_DETAILS', []);
    this.$store.dispatch('faxEmail/getFaxDataByOrderId', {
      batchNumber: this.$route.query.batchNo ? this.$route.query.batchNo : 0,
      orderNumber: this.$route.query.orderId ? this.$route.query.orderId : 0,
    });
    this.$store.commit('divvySystemMessage/SET_MODAL_MESSAGE', '');
  },
};
</script>

<style>
.textCentre {
  text-align: center;
}
.fontWeight {
  font-weight: 500;
}
.borderLeft {
  border-left: 2px solid #ced4da;
}
.borderDotted {
  border-top: 2px dotted;
}
.marginPaddingZero {
  margin: 0;
  padding: 0;
}
table {
  border-collapse: collapse;
  width: 100%;
}

tr {
  border-bottom: 1px solid #ddd;
}

.textUnderline {
  text-decoration: underline;
}

.borderClass {
  border: 2px solid;
}

.buttonStyle {
  border-radius: 1.5rem;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 9999;
}

p,
b,
th,
td {
  color: black;
}
</style>
